<div class="" *ngIf="imageObjects.length>0">
  <div class="contain">
    <!--<div class="custom-slider">
      <div class="slider-container">
        <img *ngFor="let image of imageObjects; let i = index"
             [src]="image.image"
             (click)="imageClick(image.routerLink)"
             [class.active]="i === currentIndex" />
      </div>
      <div class="navigation">
        <button (click)="prevImage()">Previous</button>
        <button (click)="nextImage()">Next</button>
      </div>
    </div>-->
    <ng-image-slider 
      [images]="imageObjects" 
      [manageImageRatio]="false" 
      (click)="imageClick($event)" 
      [imagePopup]="false" 
      [imageSize]="sliderstyle" 
      [animationSpeed]="0.4" 
      [infinite]="imageObjects.length>5?true:false"
      [autoSlide]="false"
      [showArrow]="imageObjects.length>5?true:false"
      #nav></ng-image-slider>
  </div>




  
</div>


